import { captureException } from '@sentry/react'
import { QueryClient, QueryCache } from '@tanstack/react-query'
import axios from 'axios'

import { isNetworkError } from 'lib/queryErrors'

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (isNetworkError(error)) return
      if (axios.isCancel(error)) return
      try {
        captureException(error)
      } catch {
        // Sentry may be blocked by adblocker
      }
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60 * 24, //one day
      gcTime: 1000 * 60 * 60 * 24, //one day
      refetchOnWindowFocus: false,
    },
  },
})
